<template>
   <div class="container flex flex-column">
      <Header :title="title" :showBack="true" v-if="!isFromTicketChange"></Header>
      <div class="header">请选择线路</div> 
      <van-search v-model="searchLine" placeholder="请输入线路名称" clear-trigger="always"/>
      <div class="lineClass flex flex-column">
         <div class="line">
            <span @click="selectLineClick(item, index)" :key="item.id" v-for="(item, index) of lineList"
               :class="{ current: item.selectState }">
               {{ item.LineName }}
            </span>
         </div>
      </div>
      <div @click="btnClick" class="btn" :class="{ current: isSelected }">
         选好了
      </div>
   </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
export default {
   components: {
      Header,
   },
   data() {
      return {
         title: '线路班次',  
         searchLine: "", // 搜索线路
         originLineList: [], // 保存完整原始数据
         lineList: [], // 线路列表
         isSelected: false, // 是否已经选中线路
         selectLineGID: '', // 选中线路GID
         isFromTicketChange: false, // 是否来自换乘页面
         salePageName: 'LineClassDaySale' // 选择站点页面名称
      }
   },
   methods: {
      getGetCompLine() {
         let params = {
            OrganizationGID: JSON.parse(window.localStorage.getItem('adminInfo'))
               .OrganizationGID,
         }
         this.$http
            .post(this.$api.getGetCompLine, this.$qs.stringify(params))
            .then((res) => {
               console.log(res)
               if (res.success) {
                  this.lineList = []
                  res.data.forEach((item) => {
                     if (item.LineIsEnabled) {
                        item.selectState = false
                        this.lineList.push(item)
                     }
                  })

                  this.originLineList = this.lineList
                  // this.lineList = res.data
                  // this.lineList.forEach((item) => {
                  //   item.selectState = false
                  // })
               }
            })
            .catch((err) => {
               console.log(err)
               this.$dialog.alert({
                  title: '提示',
                  message: err,
               })
            })
      },
      // 选择线路
      selectLineClick(item, index) {
         var List = JSON.parse(JSON.stringify(this.lineList))
         List.forEach((item) => {
            this.$set(item, 'selectState', false)
         })
         List[index].selectState = true
         this.lineList = []
         this.lineList = List

         // 选择线路后 使按钮为可点击
         this.isSelected = true

         this.selectLineGID = item.LineGID
      },
      btnClick() {
         if (window.sessionStorage) {
            window.sessionStorage.setItem('LineGID', this.selectLineGID)
         }
         let routerParams = {
            name: this.salePageName,
            params: {
               selectLineGID: this.selectLineGID,
            },
         };
         // 嵌套在换乘页面不需要留下记录
         if (this.isFromTicketChange) {
            this.$router.replace(routerParams);
         } else {
            this.$router.push(routerParams);
         }
      },
   },
   watch: {
      searchLine(newVal) {
         if (newVal) {
            this.lineList = this.originLineList.filter((item) => {
               return item.LineName.includes(newVal)
            })
         } else {
            this.lineList = this.originLineList
         }
      },
   },
   created() {
      if (this.$route.path == '/TicketChange/LineClass') {
         this.isFromTicketChange = true;
         this.salePageName = 'TicketChangeLineClassDaySale'
      }
   },
   mounted() {
      this.getGetCompLine()
   },
}
</script>

<style scoped lang="less">
.container {
   height: 100vh;
}

.header {
   width: 100%;
   height: 1rem;
   line-height: 1rem;
   font-size: 0.44rem;
   background-color: #ccc;
   color: #fff;
}

.lineClass {
   width: 100%;
   flex: 1;
   overflow: auto;

   .line {
      width: 100%;
      height: 100%; //calc(100vh - 3.4375rem);
      display: flex;
      // justify-content: space-between;
      flex-direction: column;
      font-size: 0.4rem;
      overflow-y: scroll;

      span {
         width: 100%;
         height: 1rem;
         line-height: 1rem;
         background-color: #fff;
         color: #333;
         margin-top: 0.2rem;
         border-bottom: 1px solid #eee;
      }

      span.current {
         background: #ffb870;
         color: #fff;
      }
   }
}


.btn {
   width: 100%;
   height: 1rem;
   line-height: 1rem;
   color: #fff;
   background: #ccc;
   // position: fixed;
   // bottom: 0;
   // left: 0;
   // right: 0;
   font-size: 0.44rem;
}

.btn.current {
   background: #ffb870;
   color: #fff;
}
</style>
